/**
 * Input Schema of Auditoria
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {Auditoria} from '@/model/resource/Auditoria'
import {AuditoriaMotivoCollection} from '@/model/collection/AuditoriaMotivoCollection'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputAuditoriaSchema extends Schema {
  collectionAuditoriaMotivo = new AuditoriaMotivoCollection().noPagination()
  collectionCarga = new CargaCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputAuditoria'

  readonly fieldSet: FieldSet<Auditoria> = {
    auditoriaMotivo: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionAuditoriaMotivo.all(),
      },
    }),
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    conforme: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    dataCanhoto: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
